/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Alternatives_View_AllInputs */

const en_directory_alternatives_view_all = /** @type {(inputs: Directory_Alternatives_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`View all ${i?.name} alternatives`)
};

const zh_directory_alternatives_view_all = /** @type {(inputs: Directory_Alternatives_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`查看 ${i?.name} 的全部替代工具`)
};

/**
* | output |
* | --- |
* | "View all {name} alternatives" |
*
* @param {Directory_Alternatives_View_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_alternatives_view_all = /** @type {((inputs: Directory_Alternatives_View_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Alternatives_View_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_alternatives_view_all(inputs)
	return zh_directory_alternatives_view_all(inputs)
});
export { directory_alternatives_view_all as "directory.alternatives.view_all" }